import { AfterViewInit, Directive, ElementRef, OnDestroy } from '@angular/core';

/**
 * Auto-adds native `title` attribute to all mat-cell elements
 * when their text overflows (ellipsis is active).
 * Applies automatically to any element with class `table-wrapper`.
 */
@Directive({
  selector: '.table-wrapper',
  standalone: true
})
export class CellTooltipDirective implements AfterViewInit, OnDestroy {

  private observer?: MutationObserver;

  constructor(private el: ElementRef<HTMLElement>) {}

  ngAfterViewInit(): void {
    this.applyTitles();

    this.observer = new MutationObserver(() => this.applyTitles());
    this.observer.observe(this.el.nativeElement, { childList: true, subtree: true });
  }

  private applyTitles(): void {
    requestAnimationFrame(() => {
      const cells = this.el.nativeElement.querySelectorAll('.mat-mdc-cell');
      cells.forEach((cell: Element) => {
        const el = cell as HTMLElement;
        if (el.scrollWidth > el.clientWidth) {
          el.title = el.textContent?.trim() || '';
        } else {
          el.removeAttribute('title');
        }
      });
    });
  }

  ngOnDestroy(): void {
    this.observer?.disconnect();
  }
}
